import getCommonFilterSettings from './common';

export default {
    getCommonFilterSettings
};